.mainPaper {
	max-width: 50% !important;
	padding: 40px;
	padding-right: 50px;
	padding-left: 50px;
	margin-top: 50px;
	margin-bottom: 50px;
	margin-left: auto;
	margin-right: auto;
}

.licenceType {
	justify-content: center;
}

.academicLicenceIcon {
	color: var(--green);
	font-size: 2.125rem !important;
}

.submitButton {
	margin-top: 8px !important;
}

@media (max-width: 540px) {
	.mainPaper {
		max-width: 100vw !important;
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
}
